<template>
  <div class="admin-user-page">
    <tableComponents
      :pagination="{
        currentPage: pagination.page,
        pageSize: pagination.page_size,
        total,
      }"
      :searchData="adminSearchData"
      :isHaveExport="false"
      :isHaveAdd="$hasPermission('admin_user:create')"
      addText="新增管理员"
      @sendUserSearch="handleSearch"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @toAdd="openEditor()"
    >
      <template #table>
        <el-table :data="list" border stripe v-loading="loading">
          <el-table-column prop="username" label="账号" min-width="140" />
          <el-table-column prop="nickname" label="昵称" min-width="120" />
          <el-table-column label="角色" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="row.rating == 1 ? '' : 'info'">
                {{ row.rating == 1 ? "超级管理员" : "普通管理员" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="row.status == 1 ? 'success' : 'danger'">
                {{ row.status == 1 ? "启用" : "禁用" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="180" />
          <el-table-column label="最近登录" min-width="160" align="center">
            <template slot-scope="{ row }">
              {{ $fnc.getTimeFormat(row.last_login_time, "ymdhms") }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="160" align="center">
            <template slot-scope="{ row }">
              {{ $fnc.getTimeFormat(row.created_time, "ymdhms") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="menu_count"
            label="菜单授权数"
            width="110"
            align="center"
          />
          <el-table-column
            prop="app_count"
            label="APP 授权数"
            width="110"
            align="center"
          />
          <el-table-column label="操作" width="420" align="center" fixed="right">
            <template slot-scope="{ row }">
              <el-button
                v-permission="'admin_user:update'"
                size="mini"
                type="primary"
                plain
                @click="openEditor(row)"
              >
                编辑
              </el-button>
              <el-button
                v-if="$hasPermission('admin_user:assign')"
                size="mini"
                type="warning"
                plain
                @click="openPermissionDialog(row)"
              >
                {{ row.rating == 1 ? "查看权限" : "权限分配" }}
              </el-button>
              <el-button
                v-if="$hasPermission('admin_user:assign')"
                size="mini"
                type="success"
                plain
                @click="openAppPermissionDialog(row)"
              >
                {{ row.rating == 1 ? "查看APP" : "APP授权" }}
              </el-button>
              <el-button
                v-if="
                  $hasPermission('admin_user:delete') &&
                  Number(row.id) !== Number(currentAdminId)
                "
                size="mini"
                type="danger"
                plain
                @click="removeAdmin(row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </tableComponents>

    <el-dialog
      :title="editorTitle"
      :visible.sync="editorVisible"
      width="640px"
      @closed="resetEditor"
    >
      <el-form
        ref="editorForm"
        :model="editorForm"
        :rules="editorRules"
        label-width="110px"
      >
        <el-form-item label="账号" prop="username">
          <el-input
            v-model.trim="editorForm.username"
            :disabled="editorMode === 'edit'"
            placeholder="请输入管理员账号"
          />
        </el-form-item>

        <el-form-item
          :label="editorMode === 'edit' ? '新密码' : '密码'"
          :prop="editorMode === 'edit' ? '' : 'password'"
        >
          <el-input
            v-model.trim="editorForm.password"
            type="password"
            show-password
            :placeholder="
              editorMode === 'edit'
                ? '留空表示不修改密码'
                : '请输入登录密码'
            "
          />
        </el-form-item>

        <el-form-item label="昵称" prop="nickname">
          <el-input
            v-model.trim="editorForm.nickname"
            placeholder="请输入管理员昵称"
          />
        </el-form-item>

        <el-form-item label="角色" prop="rating">
          <el-radio-group v-model="editorForm.rating">
            <el-radio :label="1">超级管理员</el-radio>
            <el-radio :label="2">普通管理员</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-switch
            v-model="editorForm.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          />
        </el-form-item>

        <el-form-item label="备注">
          <el-input
            v-model.trim="editorForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注信息"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitEditor">
          保存
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="permissionTitle"
      :visible.sync="permissionVisible"
      width="720px"
    >
      <div class="permission-tip">
        <el-alert
          v-if="permissionReadonly"
          type="info"
          :closable="false"
          show-icon
          title="超级管理员默认拥有全部权限，当前仅展示权限树。"
        />
      </div>
      <el-tree
        ref="permissionTreeRef"
        :data="permissionTree"
        node-key="id"
        show-checkbox
        default-expand-all
        :check-strictly="false"
        :props="{ label: 'title', children: 'children' }"
        :default-checked-keys="checkedPermissionIds"
      >
        <span slot-scope="{ data }" class="permission-node">
          <span>{{ data.title }}</span>
          <el-tag size="mini" effect="plain">{{ data.type }}</el-tag>
          <el-tag
            v-if="data.permission_key"
            size="mini"
            type="info"
            effect="plain"
          >
            {{ data.permission_key }}
          </el-tag>
        </span>
      </el-tree>

      <span slot="footer" class="dialog-footer">
        <el-button @click="permissionVisible = false">关闭</el-button>
        <el-button
          v-if="!permissionReadonly"
          type="primary"
          :loading="permissionSaving"
          @click="submitPermission"
        >
          保存权限
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="appPermissionTitle"
      :visible.sync="appPermissionVisible"
      width="720px"
    >
      <div class="permission-tip">
        <el-alert
          v-if="appPermissionReadonly"
          type="info"
          :closable="false"
          show-icon
          title="超级管理员默认可访问全部 APP，当前仅用于展示授权结果。"
        />
      </div>

      <el-checkbox-group
        v-model="checkedAppIds"
        :class="['app-permission-list', appPermissionReadonly ? 'readonly' : '']"
      >
        <el-checkbox
          v-for="item in appOptions"
          :key="item.id"
          :label="item.id"
          border
          :disabled="appPermissionReadonly"
        >
          {{ item.app_name }}
        </el-checkbox>
      </el-checkbox-group>

      <span slot="footer" class="dialog-footer">
        <el-button @click="appPermissionVisible = false">关闭</el-button>
        <el-button
          v-if="!appPermissionReadonly"
          type="primary"
          :loading="appPermissionSaving"
          @click="submitAppPermission"
        >
          保存 APP 授权
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      saving: false,
      permissionSaving: false,
      appPermissionSaving: false,
      total: 0,
      list: [],
      queryForm: {},
      pagination: {
        page: 1,
        page_size: 10,
      },
      editorVisible: false,
      editorMode: "create",
      editorForm: {
        id: "",
        username: "",
        password: "",
        nickname: "",
        rating: 2,
        status: 1,
        remark: "",
      },
      editorRules: {
        username: [
          { required: true, message: "请输入管理员账号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
        ],
        nickname: [
          { required: true, message: "请输入管理员昵称", trigger: "blur" },
        ],
        rating: [
          { required: true, message: "请选择管理员角色", trigger: "change" },
        ],
      },
      permissionVisible: false,
      permissionTitle: "权限分配",
      permissionTree: [],
      checkedPermissionIds: [],
      currentPermissionUserId: "",
      permissionReadonly: false,
      appPermissionVisible: false,
      appPermissionReadonly: false,
      appPermissionTitle: "APP 授权",
      currentAppPermissionUserId: "",
      checkedAppIds: [],
      appOptions: [],
    };
  },
  computed: {
    adminSearchData() {
      return () => [
        {
          title: "",
          type: "2",
          data: [
            { type: "text", key: "username", placeholder: "搜索账号" },
            { type: "text", key: "nickname", placeholder: "搜索昵称" },
            {
              type: "select",
              key: "rating",
              placeholder: "角色",
              option: [
                { id: 1, title: "超级管理员" },
                { id: 2, title: "普通管理员" },
              ],
              onChange: () => {},
            },
            {
              type: "select",
              key: "status",
              placeholder: "状态",
              option: [
                { id: 1, title: "启用" },
                { id: 0, title: "禁用" },
              ],
              onChange: () => {},
            },
          ],
        },
      ];
    },
    editorTitle() {
      return this.editorMode === "edit" ? "编辑管理员" : "新增管理员";
    },
    currentAdminId() {
      return this.$store.state.adminInfo.id;
    },
  },
  methods: {
    normalizeEditorPayload() {
      const payload = {
        ...this.editorForm,
        rating: Number(this.editorForm.rating),
        status: Number(this.editorForm.status),
        remark: this.editorForm.remark || "",
      };

      if (!payload.password) {
        delete payload.password;
      }

      return payload;
    },
    async getList() {
      this.loading = true;
      try {
        const data = await this.$api.getAdmin.getList({
          ...this.pagination,
          ...this.queryForm,
        });
        this.list = data.data.list || [];
        this.total = data.data.count || 0;
      } finally {
        this.loading = false;
      }
    },
    handleSearch(form) {
      this.queryForm = form;
      this.pagination.page = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.pagination.page_size = size;
      this.getList();
    },
    resetEditor() {
      this.$refs.editorForm && this.$refs.editorForm.resetFields();
      this.editorForm = {
        id: "",
        username: "",
        password: "",
        nickname: "",
        rating: 2,
        status: 1,
        remark: "",
      };
    },
    async openEditor(row) {
      this.editorMode = row ? "edit" : "create";
      this.editorVisible = true;

      if (!row) {
        return;
      }

      const data = await this.$api.getAdmin.getInfo({ id: row.id });
      const info = data.data || {};
      this.editorForm = {
        id: info.id,
        username: info.username || "",
        password: "",
        nickname: info.nickname || "",
        rating: Number(info.rating || 2),
        status: Number(info.status ?? 1),
        remark: info.remark || "",
      };
    },
    async submitEditor() {
      const valid = await new Promise((resolve) => {
        this.$refs.editorForm.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.saving = true;
      try {
        const payload = this.normalizeEditorPayload();
        const request = payload.id
          ? this.$api.getAdmin.postSave(payload)
          : this.$api.getAdmin.postAdd(payload);
        const data = await request;
        if (data.code === 200) {
          this.$message.success("保存成功");
          this.editorVisible = false;
          this.getList();
        }
      } finally {
        this.saving = false;
      }
    },
    async removeAdmin(row) {
      this.$confirm(`确认删除管理员 ${row.username} 吗？`, "删除确认", {
        type: "warning",
      }).then(async () => {
        const data = await this.$api.getAdmin.postDel({ id: row.id });
        if (data.code === 200) {
          this.$message.success("删除成功");
          this.getList();
        }
      });
    },
    async openPermissionDialog(row) {
      this.currentPermissionUserId = row.id;
      this.permissionReadonly = Number(row.rating) === 1;
      this.permissionTitle = this.permissionReadonly
        ? `查看权限 - ${row.nickname || row.username}`
        : `权限分配 - ${row.nickname || row.username}`;

      const [treeData, checkedData] = await Promise.all([
        this.$api.getAdmin.getPermissionTree(),
        this.$api.getAdmin.getPermissionInfo({ id: row.id }),
      ]);

      this.permissionTree = treeData.data || [];
      this.checkedPermissionIds = checkedData.data.checked_ids || [];
      this.permissionVisible = true;

      this.$nextTick(() => {
        this.$refs.permissionTreeRef.setCheckedKeys(this.checkedPermissionIds);
        if (this.$refs.permissionTreeRef.store.nodesMap) {
          Object.values(this.$refs.permissionTreeRef.store.nodesMap).forEach(
            (node) => {
              node.disabled = this.permissionReadonly;
            }
          );
        }
      });
    },
    async submitPermission() {
      const checkedKeys = this.$refs.permissionTreeRef.getCheckedKeys();
      const halfKeys = this.$refs.permissionTreeRef.getHalfCheckedKeys();
      const permission_ids = [...new Set([...checkedKeys, ...halfKeys])];

      this.permissionSaving = true;
      try {
        const data = await this.$api.getAdmin.postPermissionSave({
          id: this.currentPermissionUserId,
          permission_ids,
        });
        if (data.code === 200) {
          this.$message.success("权限保存成功");
          this.permissionVisible = false;
          this.getList();
        }
      } finally {
        this.permissionSaving = false;
      }
    },
    async ensureAppOptions() {
      if (this.appOptions.length) {
        return;
      }
      const data = await this.$api.getApp.getAppList({ page: 1, page_size: 10000 });
      this.appOptions = data.data.list || [];
    },
    async openAppPermissionDialog(row) {
      await this.ensureAppOptions();
      this.currentAppPermissionUserId = row.id;
      this.appPermissionReadonly = Number(row.rating) === 1;
      this.appPermissionTitle = this.appPermissionReadonly
        ? `查看 APP 授权 - ${row.nickname || row.username}`
        : `APP 授权 - ${row.nickname || row.username}`;

      const data = await this.$api.getAdmin.getAppPermissionInfo({ id: row.id });
      this.checkedAppIds = data.data.app_ids || [];
      this.appPermissionVisible = true;
    },
    async submitAppPermission() {
      this.appPermissionSaving = true;
      try {
        const data = await this.$api.getAdmin.postAppPermissionSave({
          id: this.currentAppPermissionUserId,
          app_ids: this.checkedAppIds,
        });
        if (data.code === 200) {
          this.$message.success("APP 授权保存成功");
          this.appPermissionVisible = false;
          this.getList();
        }
      } finally {
        this.appPermissionSaving = false;
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.admin-user-page {
  height: 100%;
}

.permission-tip {
  margin-bottom: 12px;
}

.permission-node {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.app-permission-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  &.readonly {
    opacity: 0.9;
  }
}

/deep/ .app-permission-list .el-checkbox {
  margin-right: 0;
}

/deep/ .el-table .el-table__cell {
  padding: 8px 0;
}
</style>
